module.exports = __webpack_public_path__ + "static/media/S (194).a5d85a09.jpg";